import request from '@/utils/request';
/**
 * 新增员工
 */
export function addApi(data) {
  return request({
    url: "/admin/customers/emp/add",
    method: 'POST',
    data: data
  });
}

/**
 * 修改员工
 */
export function updateApi(data) {
  return request({
    url: "/admin/customers/emp/update",
    method: 'PUT',
    data: data
  });
}

/**
 * 修改员工状态
 */
export function empUpdateApi(params) {
  return request({
    url: "/admin/customers/emp/update/".concat(params.id, "/").concat(params.status),
    method: 'PUT'
  });
}

/**
 * 查询客户员工列表
 */
export function listApi(params) {
  return request({
    url: "/admin/customers/emp/list",
    method: 'GET',
    params: params
  });
}

/**
 * 导出员工列表
 * @param {Number} customerIntegralId - 客户积分ID
 * @param {Object} params - 查询参数（与 listApi 相同）
 */
export function exportEmpApi(customerIntegralId, params) {
  return request({
    url: "/admin/customers/emp/export/".concat(customerIntegralId),
    method: 'GET',
    params: params
  });
}

/**
 * 导出员工列表
 * @param {Object} params - 查询参数（与 listApi 相同）
 */
export function exportUserFuCardInfo(params) {
  return request({
    url: "/admin/customers/emp/export/exportUserFuCardInfo",
    method: 'GET',
    params: params
  });
}